import { getColorStyles } from './utilities/get-color-styles';
import template from './color-dots.component.html';
var colorAttribute = 'product_mobcolorhex';
var ColorDotsComponentController = /** @class */ (function () {
    function ColorDotsComponentController() {
        this.colorDots = [];
        this.size = 16;
    }
    ColorDotsComponentController.prototype.$onChanges = function () {
        this.colorDots = (this.attributes || [])
            .filter(function (attribute) { return attribute.toLowerCase()
            .indexOf(colorAttribute) === 0; })
            .filter(function (attribute, index, self) { return self.indexOf(attribute) === index; })
            .map(function (attribute) { return attribute.split('|')
            .slice(1)
            .join('|'); })
            .map(getColorStyles);
    };
    Object.defineProperty(ColorDotsComponentController.prototype, "hasColorDots", {
        get: function () {
            return !!(this.colorDots && this.colorDots.length > 1);
        },
        enumerable: false,
        configurable: true
    });
    ColorDotsComponentController.$inject = [];
    return ColorDotsComponentController;
}());
export var ColorDotsComponent = {
    bindings: {
        attributes: '<',
        size: '@',
    },
    controller: ColorDotsComponentController,
    template: template,
};
